import { Map, List, fromJS } from 'immutable'

export function users(state = List(), action) {
  switch (action.type) {
    case 'USER_FETCH_SUCCESS':
      return fromJS(action.items || [])
    default:
      return state
  }
}

export function usersLoading(state = true, action) {
  switch (action.type) {
    case 'USER_FETCH_SUCCESS':
    case 'USER_FETCH_ERROR':
      return false
    default:
      return state
  }
}

export function usersError(state = false, action) {
  switch (action.type) {
    case 'USER_FETCH_ERROR':
      return action.message
    default:
      return state
  }
}
